export default "__VITE_ASSET__B4o9nlDq__"